import { useState, type ReactNode } from 'react'
import type { Mode } from './types/Mode'
import { ModeContext } from './mode-context'

export function ModeProvider({ children }: { children: ReactNode }) {
  const [mode, setMode] = useState<Mode>('realism')
  return (
    <ModeContext.Provider value={{ mode, setMode }}>
      {children}
    </ModeContext.Provider>
  )
}
